import React from 'react';
import {Skeleton} from '@mui/material';
import {LinkInviteScreenType} from '@practicegenius/register-account/src/screens/LinkInvite';
import {BaseScreen} from '../../../components/screens/BaseScreen';

export const LinkInvite: LinkInviteScreenType = ({lang}) => {
  return (
    <BaseScreen helmetTitle={lang.pageTitle} headerTitle={lang.headerTitle}>
      <Skeleton variant="text" animation="wave" />
      <Skeleton variant="text" animation="wave" />
      <Skeleton variant="text" animation="wave" />
    </BaseScreen>
  );
};
